import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { Opportunity } from "../types/crm";
import { QuickAddModal } from "./QuickAddModal";
import { Sidebar } from "./Sidebar";

export function AppShell() {
  const navigate = useNavigate();
  const [quickAddOpen, setQuickAddOpen] = useState(false);

  const handleCreated = (opportunity: Opportunity) => {
    setQuickAddOpen(false);
    // Leva o usuário ao Kanban já com o novo lead visível. O state força o
    // refetch da página do pipeline mesmo quando ela já está montada.
    navigate("/pipeline", { state: { createdOpportunityId: opportunity.id, ts: Date.now() } });
  };

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main className="flex flex-1 flex-col bg-primary-faint">
        <header className="flex items-center justify-end border-b border-border-soft bg-white/70 px-8 py-3 backdrop-blur">
          <button
            type="button"
            onClick={() => setQuickAddOpen(true)}
            className="rounded-[10px] bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark"
          >
            + Novo lead
          </button>
        </header>
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </main>

      {quickAddOpen && (
        <QuickAddModal onClose={() => setQuickAddOpen(false)} onCreated={handleCreated} />
      )}
    </div>
  );
}
